import { CardString } from 'pokersolver'
import { DS } from '../../design-system'
import { Card } from '../ANewDesign/Card'
import { verticalScale } from '../../styles/sizes'
import { StyleSheet } from 'react-native'
import { TouchableOpacity } from 'react-native-gesture-handler'
import { useCallback } from 'react'

type TwoCardsProps = {
  onSend: (leftCardShown: boolean, rightCardShown: boolean) => void
  opacity?: boolean
  cards?: (string | CardString | undefined)[]
}

export const TwoCards = ({ cards, onSend, opacity }: TwoCardsProps) => {
  const onSendCards = useCallback(() => {
    if (cards) {
      onSend(Boolean(cards[0]), Boolean(cards[1]))
    }
  }, [cards, onSend])

  return (
    <TouchableOpacity onPress={onSendCards}>
      <DS.Frame
        style={[styles.container, opacity ? styles.opacity : {}]}
        row
        justifyContent="center"
        alignItems="center"
      >
        <Card card={cards?.[0]} fontSize={verticalScale(15)} rotateDegrees="-5deg" shadow makeSound />
        <Card card={cards?.[1]} fontSize={verticalScale(15)} rotateDegrees={'5deg'} shadow makeSound />
      </DS.Frame>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: DS.spacing['24'],
    paddingVertical: DS.spacing['8'],
    borderRadius: 96,
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey']
  },
  opacity: {
    backgroundColor: DS.palette['Brand/Light Grey']
  }
})
